import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose';
import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/esm/taggedTemplateLiteralLoose';
import React from 'react';
import styled from '@xstyled/styled-components';
import { Box } from '@trybeapp/ui.box';
import { themePath, system } from '@trybeapp/ui.system';
import { cardStyles } from '@trybeapp/ui.utilities';
import { Shape } from '@trybeapp/ui.shape';

var _excluded = ["children"],
  _excluded2 = ["src", "alt"];
var _templateObject, _templateObject2, _templateObject3;
var StyledCard = /*#__PURE__*/styled(Box)(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n  background-size: cover;\n  background-position: center;\n\n  ", "\n"])), cardStyles, /*#__PURE__*/themePath('cards.default'), system);
var StyledBody = /*#__PURE__*/styled(Box)(_templateObject2 || (_templateObject2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding: 4;\n  word-break: break-word;\n\n  ", "\n"])), system);
var StyledCover = /*#__PURE__*/styled(Shape)(_templateObject3 || (_templateObject3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  ", "\n"])), /*#__PURE__*/themePath('cards.cover'), system);
var Card = function Card(_ref) {
  var children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledCard, rest, children);
};
Card.displayName = 'Card';
var Cover = function Cover(_ref2) {
  var src = _ref2.src,
    _ref2$alt = _ref2.alt,
    alt = _ref2$alt === void 0 ? '' : _ref2$alt,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(StyledCover, props, /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: alt
  }));
};
Card.Body = StyledBody;
Card.Cover = Cover;

export { Card, Cover };
